import { Component } from '@angular/core';
import { HomepagedataService } from '../services/homepagedata.service';
import { PageLoadingService } from '../utils/page-loading/page-loading.service';
import { categoryAndModelCategory, messagesOnScreen, regionObject, sessionStorageObject } from '../utils/constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-metrics-report',
  templateUrl: './metrics-report.component.html',
  styleUrls: ['../base.scss', './metrics-report.component.scss']
})

export class MetricsReportComponent {
  spinnerMsg = messagesOnScreen.gettingMetricsLoader;
  todaysDate = new Date();
  metricsForm: FormGroup = new FormGroup({});
  metricsData: any = null;
  locations = [];

  constructor(
    private loader: PageLoadingService,
    private HomepageService: HomepagedataService) {
    this.createFormgroup();
    this.locations = JSON.parse(sessionStorage.getItem(sessionStorageObject.allgeoCat));
  }

  createFormgroup() {
    this.metricsForm = new FormGroup({
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl(this.todaysDate, Validators.required),
      regionCategory: new FormControl('', Validators.required)
    });
  }

  onSubmit() {
    if (this.metricsForm.valid) {
      const startDate: Date = this.metricsForm.value.startDate;
      const endDate: Date = this.metricsForm.value.endDate;
      const startDateConv = `${startDate.getFullYear()}-${startDate.toLocaleString('en-US', { month: '2-digit' })}-${startDate.toLocaleString('en-US', { day: '2-digit' })}`;
      const endDateConv = `${endDate.getFullYear()}-${endDate.toLocaleString('en-US', { month: '2-digit' })}-${endDate.toLocaleString('en-US', { day: '2-digit' })}`;
      const regionCategory: string[] = [];
      this.metricsForm.value.regionCategory.forEach((element: string) => {
        if (element != 'All') {
          let [region, category] = element.split('-');
          if (region === regionObject.chinaRegion && category === categoryAndModelCategory.nutrition) {
            category = categoryAndModelCategory.quaker;
          }
          regionCategory.push(`${region}-${category}`);
        }
      });
      if (regionCategory.length) {
        this.loader.show(this.spinnerMsg);
        this.HomepageService.getMetricsReportData(startDateConv, endDateConv, regionCategory).subscribe((data) => {
          this.metricsData = data;
          this.loader.hide();
        });
      }
    }
  }

  changeRegionCategory(event: any) {
    let regionCategory: string[] = [];
    if (event.selected === true && event.value === 'All') {
      regionCategory = JSON.parse(sessionStorage.getItem(sessionStorageObject.allgeoCat)).map(x => (x.region + '-' + x.category));
      regionCategory.push('All');
    } else if (event.value != 'All') {
      regionCategory = this.metricsForm.value.regionCategory.filter(f => f !== 'All');
      if (regionCategory.length === this.locations.length) {
        regionCategory.push('All');}
    }
    this.metricsForm.get('regionCategory')?.setValue(regionCategory);
  }
}
